module.exports={turnstile_modal:{message:"Weryfikacja szczegółów zabezpieczeń"}};